import type {GetSharedInboxConfig_sharedInboxConfig_sharedAddresses as SharedAddress} from 'nutshell-graphql-types';

export const getLastVerifiedTime = (sharedAddresses: SharedAddress[]): number | null => {
    const lastVerifiedTime = sharedAddresses.reduce((latest, address) => {
        const time = address.forwardingVerifiedTime;
        if (!time) {
            return latest;
        }

        if (!latest) {
            return time;
        }

        return Math.max(time, latest);
    }, null);

    return lastVerifiedTime;
};
